import "./style.css";
import { defineComponent as m, openBlock as r, createBlock as l, resolveDynamicComponent as k, mergeProps as d, withCtx as u, renderSlot as P, resolveComponent as B, normalizeProps as g, createElementBlock as $, Fragment as v, renderList as S, createCommentVNode as W } from "vue";
import { e as f, B as h, w } from "./index-EjEFGone.js";
import { g as R, a as b } from "./get-block-properties-ijlhyTBV.js";
const I = m({
  name: "interactive-element",
  props: ["wrapperProps", "includeBlockProps", "block", "context", "Wrapper"],
  data() {
    return { getBlockActions: R, getBlockProperties: b };
  }
});
function E(e, o, p, s, t, c) {
  return r(), l(k(e.Wrapper), d({
    attributes: e.includeBlockProps ? {
      ...e.getBlockProperties({
        block: e.block,
        context: e.context
      }),
      ...e.getBlockActions({
        block: e.block,
        rootState: e.context.rootState,
        rootSetState: e.context.rootSetState,
        localState: e.context.localState,
        context: e.context.context
      })
    } : {}
  }, e.wrapperProps), {
    default: u(() => [
      P(e.$slots, "default")
    ]),
    _: 3
  }, 16, ["attributes"]);
}
const i = /* @__PURE__ */ f(I, [["render", E]]), y = ({
  componentOptions: e,
  builderBlock: o,
  context: p,
  componentRef: s,
  includeBlockProps: t,
  isInteractive: c,
  contextValue: a
}) => {
  const n = {
    ...e,
    /**
     * If `noWrap` is set to `true`, then the block's props/attributes are provided to the
     * component itself directly. Otherwise, they are provided to the wrapper element.
     */
    ...t ? {
      attributes: b({
        block: o,
        context: a
      })
    } : {}
  };
  return c ? {
    Wrapper: s,
    block: o,
    context: p,
    wrapperProps: e,
    includeBlockProps: t
  } : n;
}, A = m({
  name: "component-ref",
  components: { Block: h, InteractiveElement: i },
  props: [
    "isInteractive",
    "componentRef",
    "componentOptions",
    "builderBlock",
    "context",
    "linkComponent",
    "includeBlockProps",
    "blockChildren",
    "registeredComponents"
  ],
  data() {
    return {
      Wrapper: this.isInteractive ? w(i) : this.componentRef,
      getWrapperProps: y
    };
  }
});
function O(e, o, p, s, t, c) {
  const a = B("block");
  return e.componentRef ? (r(), l(k(e.Wrapper), g(d(
    { key: 0 },
    e.getWrapperProps({
      componentOptions: e.componentOptions,
      builderBlock: e.builderBlock,
      context: e.context,
      componentRef: e.componentRef,
      linkComponent: e.linkComponent,
      includeBlockProps: e.includeBlockProps,
      isInteractive: e.isInteractive,
      contextValue: e.context
    })
  )), {
    default: u(() => [
      (r(!0), $(v, null, S(e.blockChildren, (n, C) => (r(), l(a, {
        key: n.id,
        block: n,
        context: e.context,
        registeredComponents: e.registeredComponents,
        linkComponent: e.linkComponent
      }, null, 8, ["block", "context", "registeredComponents", "linkComponent"]))), 128))
    ]),
    _: 1
  }, 16)) : W("", !0);
}
const L = /* @__PURE__ */ f(A, [["render", O]]);
export {
  L as default
};
